<template>
    <v-tabs-items :value="tab" touchless class="h-100 scroll-primary pr-10" style="flex: 0 1 auto; overflow-y: auto; overflow-x: hidden">
        <tab-disabled :tabValue="TABS.DISABLED" v-bind="{ meeting }">
            <template #tab-complete-actions>
                <slot name="tab-complete-actions" />
            </template>
        </tab-disabled>
        <tab-schedule :tabValue="TABS.SCHEDULE" v-model="schedule.date" v-bind="{ meeting, schedule, loading }" v-on="{ save }" />
        <tab-complete :tabValue="TABS.COMPLETE" v-bind="{ meeting, schedule }" v-on="{ prev }">
            <template #tab-complete-actions>
                <slot name="tab-complete-actions" />
            </template>
        </tab-complete>
        <v-fade-transition>
            <v-overlay v-show="tab == TABS.LOADING" absolute color="transparent">
                <v-progress-circular size="100" width="5" color="primary" indeterminate />
            </v-overlay>
        </v-fade-transition>
    </v-tabs-items>
</template>

<script>
import api from "@/api";
import dayjs from "dayjs";
import { initMeetingSchedule } from "@/assets/variables";

import TabDisabled from "./tab-disabled.vue";
import TabSchedule from "./tab-schedule.vue";
import TabComplete from "./tab-complete.vue";

const TABS = {
    LOADING: "LOADING",
    DISABLED: "DISABLED",
    SCHEDULE: "SCHEDULE",
    COMPLETE: "COMPLETE",
};

const tabs = Object.values(TABS);

export default {
    components: {
        TabDisabled,
        TabSchedule,
        TabComplete,
    },
    props: {
        meeting: { type: Object, default: () => ({}) },
    },
    data: () => ({
        tab: TABS.LOADING,
        loading: false,
        TABS,

        schedule: initMeetingSchedule(),
    }),
    computed: {
        _applicant() {
            return this.$store.state.payload?._user;
        },
        disabled() {
            if (!this.schedule._id && this.meeting?.matching?.startsAt && this.meeting?.matching?.endsAt) {
                const isBeforeDuration = dayjs().isBefore(this.meeting.matching.startsAt);
                const isAfterDuration = dayjs().isAfter(this.meeting.matching.endsAt);
                return isBeforeDuration || isAfterDuration;
            }
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        meeting() {
            this.init();
        },
    },
    methods: {
        async init() {
            this.tab = TABS.LOADING;
            this.loading = false;

            const { _applicant } = this;
            const { _id: _meeting } = this.meeting;

            if (!_meeting) this.schedule = initMeetingSchedule({ _applicant });
            else this.schedule = (await api.v1.person.meetings.schedule.get({ _meeting }))?.schedule || initMeetingSchedule({ _meeting, _applicant });

            this.$nextTick(() => {
                if (this.disabled) this.tab = TABS.DISABLED;
                else if (this.schedule._id) this.tab = TABS.COMPLETE;
                else this.tab = TABS.SCHEDULE;
            });
        },

        async save() {
            if (this.loading) return;
            this.loading = true;

            const { post, put } = api.v1.person.meetings.schedule;

            try {
                this.schedule = (await (this.schedule?._id ? put : post)(this.schedule))?.schedule;
                this.next();
            } finally {
                this.loading = false;
            }
        },

        prev() {
            let thisTabIndex = tabs.indexOf(this.tab);
            let prevTabIndex = thisTabIndex - 1 || 0;
            this.tab = tabs[prevTabIndex];
        },
        next() {
            let thisTabIndex = tabs.indexOf(this.tab);
            let nextTabIndex = thisTabIndex + 1;
            if (nextTabIndex == tabs.length) nextTabIndex -= 1;
            this.tab = tabs[nextTabIndex];
        },
    },
};
</script>
